var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6414 10.9535C16.6414 15.363 13.0668 18.9376 8.65733 18.9376C4.24782 18.9376 0.673218 15.363 0.673218 10.9535C0.673218 6.54397 4.24782 2.96936 8.65733 2.96936C13.0668 2.96936 16.6414 6.54397 16.6414 10.9535ZM3.53444 10.9535C3.53444 13.7828 5.82803 16.0764 8.65733 16.0764C11.4866 16.0764 13.7802 13.7828 13.7802 10.9535C13.7802 8.12418 11.4866 5.83058 8.65733 5.83058C5.82803 5.83058 3.53444 8.12418 3.53444 10.9535Z",
    fill: "#00848D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3079,
    cy: 2.58147,
    r: 2.01897,
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.6578f9f22476a0d3968ff8c1fd740bda.svg";
export { ForwardRef as ReactComponent };